import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'aisDate'
})
export class AisDatePipe implements PipeTransform {

  transform(value: string|Date): any {
    let date = null;

    if (value instanceof Date) {
      date = value;
    }
    else {
      date = new Date(value);
      if (isNaN(date)) {
        console.error('Bad date value \'' + value + '\'.');
        return '';
      }
    }

    let out = date.getUTCDate() + '. ' + (date.getUTCMonth() + 1) + '. ' + date.getUTCFullYear();

    if (date.getUTCHours() > 0) {
      out += ' ' + date.getUTCHours() + '.' + (date.getUTCMinutes() < 10 ? '0' : '') + date.getUTCMinutes();
    }

    return out;
  }

}
